// @flow

import React, { Component } from 'react';
import Paper from 'material-ui/Paper';
import Menu from 'material-ui/Menu';
import MenuItem from 'material-ui/MenuItem';
import _ from 'lodash';
import $ from 'jquery';

import {no_rclick, title_culti, abrev} from './utils.js';
import App from './App.jsx';


type T_SelectCultiProps = {
  culti : string,
  shapes: Array<string>,
  cond  : boolean,
  app   : App
};



export default class SelectCulti extends Component<T_SelectCultiProps> {
  close               : () => void;  
  call_change_culti_ui: (ev: SyntheticEvent<*>, value: string) => void;
  
  
  
  constructor(props: T_SelectCultiProps) {
    super(props);
    
    this.close                = this.close.bind(this);
    this.call_change_culti_ui = this.call_change_culti_ui.bind(this);
  }
  
  
  
  close(): void {
    if (this.props.app.toolbar != null) {
      this.props.app.toolbar.setState({show_select_culti: false});
    }
  } 
  
  
  
  call_change_culti_ui(ev: SyntheticEvent<*>, value: string): void {
    this.props.app.map_ui.change_culti(value, this.close, true, true);
  }
  
  
  
  render() {
    if (_.has(this.props, 'cond') && ! this.props.cond) {
      return null;
    }
    
    const {app} = this.props;
    
    if (app.toolbar != null) {
      const m_style = {fontSize: 13, lineHeight: '30px'},
            left    = {style: {left: $('#bt_select_culti').position().left + 6}};
      
      return (
        <Paper className='float_menu' {...left}>
          <Menu onChange={this.call_change_culti_ui} desktop={true} style={{maxWidth: 250}}>
            {this.props.shapes.map((culti, num) => {
              return (
                <MenuItem
                  style={{ ...m_style, color: culti === this.props.culti ? 'red' : 'black'}}
                  value={culti}
                  key={num}
                  primaryText={(culti === this.props.culti ? '★ ' : '') + abrev(title_culti(culti), 30)}
                  onContextMenu={no_rclick}
                />
              );
            })}
          </Menu>
        </Paper>
      );
    }
    else {
      return null;
    }
  }
}



// WEBPACK FOOTER //
// ./src/SelectCulti.jsx